import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";

function Modal({
  open,
  onClose,
  title,
  subtitle,
  eyebrow,
  children,
  footer,
  width = "max-w-2xl",
  zClass = "z-50",
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className={`fixed inset-0 ${zClass} flex items-center justify-center overflow-hidden bg-slate-900/50 p-3 sm:p-4 backdrop-blur-[1px]`}
      onClick={onClose}
    >
      <div
        className={`daily-report-modal relative flex max-h-[min(92vh,900px)] w-full ${width} flex-col overflow-hidden rounded-2xl bg-white shadow-2xl`}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-start justify-between gap-3 border-b border-slate-200 bg-white px-5 py-4">
          <div className="min-w-0 flex-1 pr-2">
            {eyebrow ? (
              <p className="text-[10px] font-semibold uppercase tracking-wide text-indigo-600">
                {eyebrow}
              </p>
            ) : null}
            {title && (
              <h3
                className={`truncate text-base font-bold text-slate-900 ${
                  eyebrow ? "mt-0.5" : ""
                }`}
              >
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="mt-1 text-xs text-slate-500">{subtitle}</p>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="daily-report-modal-close inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-500 transition hover:border-slate-300 hover:bg-slate-50 hover:text-slate-700"
            aria-label="Close"
          >
            <FaTimes size={14} />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto">{children}</div>

        {footer ? (
          <div className="flex shrink-0 items-center justify-end gap-2 border-t border-slate-200 bg-white px-5 py-4">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Modal;
